<template>
  <div class="container">
    <div class="table">
      <div class="table-header">
        <div class="header__item"><a id="name" class="filter__link" >{{tableHeader}}</a></div>
      </div>
      <div class="table-content">
        <div class="table-row" v-for="(value,key) in tableData" :key="key">
          <div class="table-data">
            <b>{{beautify(key)}}</b>
          </div>
          <div class="table-data">{{value}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Table",
  props: ["tableHeader", "tableData"],
  methods: {
    beautify(string) {
      const result = string.replace(/([A-Z])/g, ' $1');
      return result[0].toUpperCase() + result.substring(1);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../sass/_variables.scss";

$base-spacing-unit: 2.4rem;
$half-spacing-unit: $base-spacing-unit / 2;

$color-alpha: #1772FF;
$color-form-highlight: #EEEEEE;


.container {
  width: 100%;
  height: 100%;
  display:flex;
  justify-content:center;
}

.table {
  width:100%;
  border-top: 1px solid $color-form-highlight;
  border-left: 1px solid $color-form-highlight;
  border-right: 1px solid $color-form-highlight;
  border-radius: 1rem;
}

.table-header {
  display:flex;
  width:100%;
  background-image: linear-gradient(
          to right bottom,
          $color-tertiary-light,
          $color-tertiary-dark
  );
  padding:($half-spacing-unit * 1.5) 0;
  border-radius: 1rem;
}

.table-row {
  display:flex;
  width:100%;
  padding: 1.2rem;

&:nth-of-type(odd) {
   background:$color-form-highlight;
 }
}

.table-data, .header__item {
  flex: 1 1 20%;
  text-align:center;
}

.header__item {
  text-transform:uppercase;
}

.filter__link {
  color: white;
  text-decoration: none;
  position: relative;
  display: inline-block;
  padding-left: $base-spacing-unit;
  padding-right: $base-spacing-unit;

  &::after {
    content: '';
    position: absolute;
    right: -($half-spacing-unit * 1.5);
    color: white;
    top: 50%;
    transform: translateY(-50%);
  }
}

</style>